import { map, findIndex, uniqBy, orderBy } from 'lodash';
const EVENT_GROUPING_THRESHOLD_IN_SECONDS = 100;

export default {
    namespaced: true,
    state: {
        showNotificationsModal: false,
        notifications: [],
    },
    mutations: {
        markAllAsRead(state) {
            state.notifications = map(state.notifications, (notif) => {
                notif.read = true;
                return notif;
            });
        },
        markAsRead(state, notification) {
            const index = findIndex(state.notifications, { timestamp: notification.timestamp });
            state.notifications[index].read = true;
        },
        addNotification(state, { event, slides, action, userName }) {
            const now = new Date();
            let notification = {
                action,
                grouping: Math.floor(now.valueOf() / EVENT_GROUPING_THRESHOLD_IN_SECONDS)
            };
            notification.uploadUserName = userName;
            
            const existingIndex = findIndex(state.notifications, notification);
            // Add the slides to an existing notification
            if (existingIndex > -1) {
                state.notifications[existingIndex].slides = uniqBy(state.notifications[existingIndex].slides.concat(slides), 'id');
                state.notifications[existingIndex].read = false;
                state.notifications[existingIndex].timestamp = now.toISOString();
            } else {
                state.notifications.push({ ...notification, slides: uniqBy(slides), read: false, timestamp: now.toISOString() });
            }

            if (!state.showNotificationsModal) {
                state.showNotificationsModal = true;
            }
        },
        toggle(state, forcedState = null) {
            if (forcedState !== null) {
                state.showNotificationsModal = forcedState;
            } else {
                state.showNotificationsModal = !state.showNotificationsModal;
            }
        },
        clearNotifications(state) {
            state.notifications = [];
        },
    },
    actions: {
        markAllAsRead({ commit }) {
            commit('markAllAsRead');
            commit('toggle', false);
        },
        markAsRead({ commit }, slide) {
            commit('markAsRead', slide);
        },
        addNotification({ commit }, slideEvent) {
            commit('addNotification', slideEvent);
        },
        toggle({ commit }) {
            commit('toggle');
        },
        hide({ commit }) {
            commit('toggle', false);
        },
        clearNotifications({ commit }) {
            commit('clearNotifications');
        }
    },
    getters: {
        hasUnreadNotifications(state, getters) {
            return getters.unreadNotifications.length > 0;
        },
        unreadNotifications(state) {
            return state.notifications.filter(notif => !notif.read);
        },
        notifications(state) {
            return orderBy(state.notifications, 'timestamp', 'desc');
        },
        showNotificationsModal(state, getters) {
            // return getters.unreadNotifications?.length && state.showNotificationsModal;
            return state.showNotificationsModal;
        },
    },
};
